import { render, staticRenderFns } from "./ModalDeleteVoucher.vue?vue&type=template&id=573a38b6"
import script from "./ModalDeleteVoucher.vue?vue&type=script&lang=js"
export * from "./ModalDeleteVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports